import React from "react";
import {observer} from "mobx-react";
import {
    IFlightSearchControllerViewModel
} from "../../../services/flight-search/flight-search-controller/flight-search-controller-view-model.interface";
import styled from "styled-components";
import {
    PsoUserOptionComponent
} from "../../territorial-continuity-regime/pso-user-option.component";
import {PsoUserOptionsEnum} from "../../../services/flight-search/flight-search-controller/pso.enums";
import {IPsoMarket} from "../../../services/stations/pso-market.interface";
import {useServices} from "../../../hooks/use-services.hook";

const UserOptionBox = styled(PsoUserOptionComponent)`
    background-color: inherit;
    border: none;
    padding: 0;
    width: fit-content;
`


interface SearchMaskPsoMarketUserOptionsInlineComponentProps {
    flightSearchController: IFlightSearchControllerViewModel;
    psoMarket: IPsoMarket;
}

export const SearchMaskPsoMarketUserOptionsInlineComponent: React.FC<SearchMaskPsoMarketUserOptionsInlineComponentProps> = observer((props) => {
    const services = useServices();
    const searchController = props.flightSearchController;

    const psoMarket = props.psoMarket;

    const renderSeasonOption = () => {
        const activeSeasons = psoMarket.getActiveSeasons(services.time.currentDate);
        if(activeSeasons.length === 0) {
            return null;
        }

        return (
            <>
                {activeSeasons.map(season => (<UserOptionBox key={season.getPsoUserOption()}
                                                                             optionValue={season.getPsoUserOption()}
                                                                             psoMarket={props.psoMarket}
                                                                             searchController={searchController}/>))}
            </>
        );
    }

    return (
        <>
            <UserOptionBox optionValue={PsoUserOptionsEnum.Resident}
                           psoMarket={props.psoMarket}
                           searchController={searchController}/>
            {renderSeasonOption()}
        </>
    )
})